import React from 'react';
import * as S from './FCTimelineDetails.styles';

const FCTimelineDetails = ({cancellationTimeline = {}}) => {
  const {
    checkInDate,
    cancellationDate,
    cardChargeDate,
    cardChargeText,
    subTitle,
    freeCancellationText,
    title,
  } = cancellationTimeline;
  const isLastDayCancelAllowed = cancellationDate === checkInDate;
  return (
    <S.FCTimelineDetailsWrapper>
      <div className="fcDetails__bar">
        <div
          className={`fcDetails__bar--complete ${
            isLastDayCancelAllowed ? 'fcWidth100' : 'fcWidth80'
          }`}
        >
          <span className="fcDetails__bar-oval" />
          <span className="fcDetails__bar-text whiteText">{freeCancellationText}</span>
          <span className="fcDetails__bar-oval" />
        </div>
      </div>
      <div className="fcDetails__bottom">
        <div className="fcDetails__bottom--left">
          <span className="latoBlack font11 blackText">NOW</span>
          {cardChargeDate && (
            <span className="barLine makeFlex column textRight">
              <span className="latoBold font11 darkGreyText appendBottom3 capText">
                {cardChargeDate}
              </span>
              {cardChargeText && (
                <span
                  className="font10 darkGreyText"
                  dangerouslySetInnerHTML={{__html: unescape(cardChargeText)}}
                />
              )}
            </span>
          )}
          {!isLastDayCancelAllowed && (
            <span className="barLine latoBlack font11 blackText capText">{cancellationDate}</span>
          )}
        </div>
        <div className="fcDetails__bottom--right">
          <span className="latoBlack font11 blackText appendBottom3 capText">{checkInDate}</span>
          <span className="font10 darkGreyText">Check-in</span>
        </div>
      </div>
    </S.FCTimelineDetailsWrapper>
  );
};
export default FCTimelineDetails;
